module.exports = __webpack_public_path__ + "static/media/alles_falsch.f3db653b.jpg";